<template>
  <div class="qrcode-container">
    <head-bar title="我的二维码" :border="true" :fixed="true"></head-bar>
    <img :src="qrBase64" class="qr-img" ref="qrImg" v-if="isShow" />
    <div class="qrcode-img-box" ref="imgBox"></div>
    <!-- <div class="caption"></div>
    <div class="qrcode-box">
      <div class="qrcode-content" ref="qrcode">
        <img :src="qrCodeSrc" />
      </div>
    </div>
    <div class="qrcode-text">
      <span>长按二维码保存图片</span>
    </div>
    <div class="service-caption">
      <span>样品批量一个价</span>
    </div>
    <div class="service-content">
      <p>主营:电阻 电容 二极管 三极管 电感 磁珠</p>
      <p>别人有的我都有,别人没有的我也有。</p>
    </div>-->
  </div>
</template>
<script>
import domtoimage from "dom-to-image";
import { getUserId, getUserNumber } from "@/utils/auth";
import QRCode from "qrcode";
import HeadBar from "@/components/HeadBar.vue";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  name: "qrCodePage",
  components: {
    HeadBar,
  },
  data() {
    return {
      qrBase64: "",
      isShow: true,
    };
  },
  beforeMount() {
    this.createQrCode();
  },
  methods: {
    createQrCode() {
      this.$toast.loading({
        message: "数据加载中...",
        duration: 0,
      });
      let _this = this;
      let qrUrl = `${
        this.$config.WEB_DOMAIN_NAME
      }account/invite/register?uid=${getUserNumber()}`;
      this.$axios
        .post(_this.$api.commonApi.getQrCode, {
          extensionUrl: qrUrl,
        })
        .then((res) => {
          let qrBase64 = res.data;
          let node = _this.$refs.qrImg;
          _this.qrBase64 = qrBase64;
          domtoimage
            .toPng(node, {
              quality: 1,
              width: 375,
            })
            .then(function (dataUrl) {
              var img = new Image();
              img.style.width = "100%";
              img.src = dataUrl;
              _this.$refs.imgBox.appendChild(img);
              _this.isShow = false;
            })
            .catch(function (error) {
              console.error("oops, something went wrong!", error);
            });
          _this.$toast.clear();
        });
    },
  },
};
</script>
<style scoped lang="less">
.qrcode-container {
  margin: 0 auto;
  width: 750px;
  padding-top: 90px;
  .caption {
    margin: 100px auto 40px;
    width: 446px;
    height: 58px;
    background-image: url("../../../public/images/user/qrcode/caption-bg.png");
    background-position: center;
    background-size: 446px 58px;
    background-repeat: no-repeat;
  }
  .qrcode-box {
    overflow: hidden;
    margin: 0 auto;
    width: 530px;
    height: 530px;
    background-color: #fff;
    .qrcode-content {
      //   margin: 50px auto;
      width: 530px;
      height: 530px;
      > img {
        margin: 0 auto;
        width: 530px;
        height: 530px;
      }
    }
  }
  .qrcode-text {
    margin: 0 auto;
    height: 80px;
    width: 530px;
    background-color: #f1ffed;
    font-size: 32px;
    line-height: 80px;
    text-align: center;
    color: #4bc227;
  }

  .service-caption {
    margin: 40px auto 0;
    font-size: 32px;
    font-weight: 400;
    text-align: center;
  }

  .service-content {
    margin: 10px auto;
    width: 530px;
    font-size: 28px;
    line-height: 1.6;
    text-align: justify;
    color: #666;
    text-align: center;
  }
  .qr-img {
    width: 750px;
  }
  .qrcode-img-box {
    width: 750px;
    img {
      width: 750px;
    }
  }
}
</style>